import cx from 'classnames';
import { Button, SimpleCallback, Text } from 'platform-components/common';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';

import './upload-plan-button.scss';

interface OwnProps {
    mix?: string;
    onClick: SimpleCallback;
}

interface Props extends OwnProps {}

export const UploadPlanButton = ({ mix, onClick }: Props) => (
    <div className={cx('upload-plan-button', mix)}>
        <div className="upload-plan-button__text">
            <Text
                className="upload-plan-button__title"
                id="calendarPlan.uploadWrapper.titleText"
                typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium}
            />
            <Text
                className="upload-plan-button__description"
                id="calendarPlan.uploadWrapper.descText"
                typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMRegular}
            />
        </div>
        <Button onClick={onClick} transparencyTheme={Button.TRANSPARENCY_THEME.LIGHT} view={Button.VIEW.SECONDARY}>
            <Text id="calendarPlan.uploadWrapper.btnText" typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMRegular} />
        </Button>
    </div>
);
